import React from 'react'
import type { TextProps } from '@vtex/admin-ui'
import { Text } from '@vtex/admin-ui'

export type ProductSkuRefTextProps = TextProps

export const ProductSkuRefText = ({
  children,
  ...props
}: ProductSkuRefTextProps) => (
  <Text variant="detail" tone="secondary" {...props}>
    {`Ref: ${children}`}
  </Text>
)
